export const statusTextColor = (status) => {
    switch (status) {
        case "success":
            return "status-success-dark";
        case "error":
            return "status-error-dark";
        case "warning":
            return "status-warning-dark";
        default:
            return "status-info-dark";
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGVscGVycy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1N0YXR1c0JveC9oZWxwZXJzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUdBLE1BQU0sQ0FBQyxNQUFNLGVBQWUsR0FBRyxDQUFDLE1BQWtCLEVBQWEsRUFBRTtJQUMvRCxRQUFRLE1BQU0sRUFBRSxDQUFDO1FBQ2YsS0FBSyxTQUFTO1lBQ1osT0FBTyxxQkFBcUIsQ0FBQztRQUMvQixLQUFLLE9BQU87WUFDVixPQUFPLG1CQUFtQixDQUFDO1FBQzdCLEtBQUssU0FBUztZQUNaLE9BQU8scUJBQXFCLENBQUM7UUFDL0I7WUFDRSxPQUFPLGtCQUFrQixDQUFDO0lBQzlCLENBQUM7QUFDSCxDQUFDLENBQUMifQ==